import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ContactMapping from './ContactMapping'
import PhoneNumberPurchaseForm from './PhoneNumberPurchaseForm'
import RemindersMessageReport from '../../common/RemindersMessageReport'
import LocationActive from './LocationActive'

import { formatReminderNumWithoutCC } from '../../services/utils'
import css from './location-row.css'
import ExtensionSelection from './ExtensionSelection'

class LocationRow extends Component {
  static propTypes = {
    availableExtensions: PropTypes.arrayOf(PropTypes.object).isRequired,
    businesses: PropTypes.arrayOf(PropTypes.object).isRequired,
    buyPhoneNumbers: PropTypes.func.isRequired,
    contactInfo: PropTypes.shape({
      active: PropTypes.bool,
      additionalRecipients: PropTypes.string,
      doctorId: PropTypes.string,
      fEmailEnd: PropTypes.string,
      fEmailStart: PropTypes.string,
      messageReportEmails: PropTypes.string,
      officeEmail: PropTypes.string,
      officePhone: PropTypes.string,
    }).isRequired,
    doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
    dso: PropTypes.bool.isRequired,
    emailsValidation: PropTypes.shape({
      errors: PropTypes.objectOf(PropTypes.shape({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
      })).isRequired,
      isValid: PropTypes.bool.isRequired,
      validStateByLocationId: PropTypes.objectOf(PropTypes.bool).isRequired,
    }).isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    location: PropTypes.shape({
      city: PropTypes.string,
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      office_email: PropTypes.string,
      street_address: PropTypes.string,
      timezone: PropTypes.string,
      website: PropTypes.string,
    }).isRequired,
    messageReportEmails: PropTypes.string.isRequired,
    pms: PropTypes.string.isRequired,
    purchasedNumbers: PropTypes.arrayOf(PropTypes.object).isRequired,
    refetchLocations: PropTypes.func.isRequired,
    requiresPhoneNumberPurchase: PropTypes.bool.isRequired,
    saveContactInfo: PropTypes.func.isRequired,
    selectedExtensions: PropTypes.arrayOf(PropTypes.number).isRequired,
    showDoctorSelect: PropTypes.bool.isRequired,
    showAdditionalRecipients: PropTypes.bool.isRequired,
    smseUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
    updateExtensions: PropTypes.func.isRequired,
    voip: PropTypes.bool.isRequired,
    saveLocationActive: PropTypes.func.isRequired,
  }

  state = {
    purchase: false,
    phoneNumberModal: {
      open: false,
      action: 'edit',
    },
    selectedBusinessId: null,
  }

  componentDidMount() {
    const { requiresPhoneNumberPurchase, purchasedNumbers } = this.props
    if (requiresPhoneNumberPurchase && purchasedNumbers.length < 1) {
      this.setPurchasable()
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.purchasedNumbers.length < 1 &&
      this.props.purchasedNumbers.length > 0
    ) {
      this.setUnpurchasable()
    } else if (
      prevProps.purchasedNumbers.length >= 1 &&
      this.props.purchasedNumbers.length < 1
    ) {
      this.setPurchasable()
    }
  }

  handleSelectedBusiness = (id) => {
    this.setState({ selectedBusinessId: id })
  }

  toggleModal = (open, action) =>
    this.setState({ phoneNumberModal: { open, action } })

  setPurchasable = () => {
    this.setState({ purchase: true })
  }
  setUnpurchasable = () => {
    this.setState({ purchase: false })
  }

  onSelect = (value) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      fEmailEnd: value.trim(),
    })
  }

  onInputChange = (e) => {
    const value = !e.target.value ? null : e.target.value.trim()
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      [e.target.name]: value,
    })
  }

  onAddRecOrMsgReportChange = (e) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      [e.target.name]: e.target.value,
    })
  }

  onDoctorSelect = (doctor) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, {
      doctorId: doctor,
    })
  }

  onActiveToggle = (active) => {
    const { location, saveContactInfo } = this.props
    saveContactInfo(location.id, { active: !active })
  }

  render() {
    const {
      businesses,
      buyPhoneNumbers,
      contactInfo,
      doctors,
      emailsValidation,
      isTopsAdmin,
      location,
      locations,
      messageReportEmails,
      pms,
      purchasedNumbers,
      requiresPhoneNumberPurchase,
      showAdditionalRecipients,
      showDoctorSelect,
      dso,
      voip,
      smseUsers,
      availableExtensions,
      selectedExtensions,
      updateExtensions,
      refetchLocations,
    } = this.props
    const { phoneNumberModal, selectedBusinessId } = this.state
    const {
      city,
      country_code: countryCode,
      id,
      name,
      office_email: officeEmail,
      office_phone: officePhone,
      state,
      street_address: streetAddress,
      timezone,
      website,
      zip,
    } = location
    const isInvalid = !emailsValidation.validStateByLocationId[id]
    const showExtensionSelection = dso && voip
    return (
      <div>
        <div className={css.wrapper}>
          <div className={css.currentContactInfo}>
            <span>{name}</span>
            <span>{streetAddress}</span>
            <span>
              {city}, {state} {zip}
            </span>
            <span>{website}</span>
            <div dangerouslySetInnerHTML={{ __html: formatReminderNumWithoutCC(officePhone, countryCode) }} />
            {/* <div>{formatReminderNumWithoutCC(officePhone, countryCode)}</div> */}
            <span>{officeEmail}</span>
            <span>{timezone}</span>
            <span>{id}</span>
            <LocationActive
              onActiveToggle={this.onActiveToggle}
              contactInfoActive={contactInfo.active}
            />
          </div>
          {this.state.purchase ? (
            <PhoneNumberPurchaseForm
              businesses={businesses}
              selectedBusinessId={selectedBusinessId}
              handleSelectedBusiness={this.handleSelectedBusiness}
              buyPhoneNumbers={buyPhoneNumbers}
              countryCode={countryCode}
              isTopsAdmin={isTopsAdmin}
              locationId={id}
              locations={locations}
              phoneNumberModalOpen={phoneNumberModal.open}
              phoneNumberModalAction={phoneNumberModal.action}
              refetchLocations={refetchLocations}
              toggleModal={this.toggleModal}
            />
          ) : (
            <ContactMapping
              additionalRecipients={contactInfo.additionalRecipients}
              businesses={businesses}
              selectedBusinessId={selectedBusinessId}
              handleSelectedBusiness={this.handleSelectedBusiness}
              doctorId={contactInfo.doctorId}
              doctors={doctors}
              fEmails={[contactInfo.fEmailStart, contactInfo.fEmailEnd]}
              isTopsAdmin={isTopsAdmin}
              isInvalid={isInvalid}
              locationCountryCode={countryCode}
              locationId={id}
              locations={locations}
              phoneNumberModal={phoneNumberModal}
              officeEmail={contactInfo.officeEmail}
              officePhone={contactInfo.officePhone}
              onAdditionalRecipientsChange={this.onAddRecOrMsgReportChange}
              onDoctorSelect={this.onDoctorSelect}
              onInputChange={this.onInputChange}
              onSelect={this.onSelect}
              pms={pms}
              purchasedNumbers={purchasedNumbers}
              refetchLocations={refetchLocations}
              requiresPhoneNumberPurchase={requiresPhoneNumberPurchase}
              showAdditionalRecipients={showAdditionalRecipients}
              showDoctorSelect={showDoctorSelect}
              smseUsers={smseUsers}
              toggleModal={this.toggleModal}
              validationError={
                isInvalid ? emailsValidation.errors[id].errorMessage : ''
              }
            />
          )}
        </div>
        <div className={css.extensions}>
          {showExtensionSelection && (
            <ExtensionSelection
              availableExtensions={availableExtensions}
              locationId={id}
              selectedExtensions={selectedExtensions}
              updateExtensions={updateExtensions}
            />
          )}
        </div>
        <div className={css.msgReport}>
          {dso && (
            <RemindersMessageReport
              help="To subscribe, type in emails separated by commas. To unsubscribe, clear emails."
              key="location-subscription"
              label="Location Message Report Subscription Recipients"
              name="messageReportEmails"
              onChange={this.onAddRecOrMsgReportChange}
              placeholder="first@example.com, second@example.com"
              value={messageReportEmails}
            />
          )}
        </div>
      </div>
    )
  }
}

export default LocationRow



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/LocationRow.js